import { useAppSelector } from "../../app/hooks";
import { selectSingleMcBimMmiValue } from "./singleMcbimItemSelectors";
import { MmiBadge } from "../MmiBadge";

export const MmiSingleItem = () => {
  const mmi = useAppSelector(selectSingleMcBimMmiValue);
  return <MmiBadge value={Number(mmi)} />;
};
